module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/register-bg-371402f2d3bf46a2956e81937bca2b84.png";